import React, { useContext } from 'react'
import NextLink, { LinkProps as NextLinkProps } from 'next/link'
import { ThemeContext } from 'styled-components'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'
import { LinkText } from '@jarvis.oddle/core/components/Typo'
import Link from '@jarvis.oddle/core/components/Link'

interface InlineTextLinkProps {
  path: NextLinkProps['href']
  text: string
  pathAs?: NextLinkProps['as']
  color?: string
  className?: string
  target?: string
}

const InlineTextLink = ({
  path,
  text,
  pathAs,
  color,
  className,
  target
}: InlineTextLinkProps): JSX.Element => {
  const theme = useContext(ThemeContext)
  const { t } = useContext(TranslationContext)

  if (target === '_blank') {
    return <Link href={pathAs} target={target} rel='noopener'>
      <LinkText
        className={className}
        color={color || theme.colorHeadingsFont}
      >
        {t(text)}
      </LinkText>
    </Link>
  }

  return (
    <NextLink href={path} as={pathAs} passHref>
      <Link>
        <LinkText
          className={className}
          color={color || theme.colorHeadingsFont}
        >
          {t(text)}
        </LinkText>
      </Link>
    </NextLink>
  )
}

export default InlineTextLink
